import React from 'react';
import classnames from 'classnames';
import { Container } from 'semantic-ui-react';
import { useApp } from 'context/AppProvider';
import MenuLeft from 'components/MenuLeft/MenuLeft';
import './DashboardLayout.scss';

function DashboardLayout({ children }) {
  const appContext = useApp();

  return (
    <Container fluid className="dashboard-layout">
      <div className="bgbouncing" />
      <MenuLeft />

      <div
        className={classnames('dashboard-layout__content', {
          collapse: appContext.menuIsOpen,
          expanded: !appContext.menuIsOpen,
        })}
      >
        {React.cloneElement(React.Children.only(children))}
      </div>
    </Container>
  );
}

export const withDashboardLayout = (Component) => (props) =>
  (
    <DashboardLayout {...props}>
      <Component {...props} />
    </DashboardLayout>
  );
